import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useState, useEffect, useReducer } from 'react';
import { useStaticQuery } from 'gatsby';
import { useDisclosure } from '@chakra-ui/react';
import { consentReducer, getConsentsFromLocal } from '../reducers/consentsReducer';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const GlobalContext = /*#__PURE__*/React.createContext({});
export const GlobalProvider = _ref => {
  let {
    children
  } = _ref;
  let localConsents = false;
  if (typeof window !== 'undefined') {
    localConsents = !!window.localStorage.getItem('int-consents');
  }
  const {
    0: primaryMenuOpen,
    1: togglePrimaryMenu
  } = useState(false);
  const {
    0: showCookieBanner,
    1: setShowCookieBanner
  } = useState(!localConsents);
  const {
    0: sidebarContent,
    1: setSidebarContent
  } = useState(null);
  const {
    isOpen: isSidebarOpen,
    onOpen: onSidebarOpen,
    onClose: onSidebarClose
  } = useDisclosure();
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      setShowCookieBanner(false);
    }
    //eslint-disable-next-line
  }, []);
  const data = useStaticQuery(query);
  const matomoTracking = !!data.allSitePlugin.nodes.filter(plugin => plugin.name === 'gatsby-plugin-matomo');
  const remoteConsents = data.allDirectusConsents.nodes;
  const availableConsents = [{
    display_name: 'Funktionale Cookies',
    description: 'Nicht personen bezogene funktionale Cookies für Webseitenfunktionen',
    link: '/datenschutz#cookies',
    default_on: true,
    consentGiven: true,
    locked: true,
    function_id: 'functional'
  }];
  const remoteMatomoConsent = remoteConsents.find(el => el.function_id === 'matomo');
  if (!remoteMatomoConsent && matomoTracking) {
    availableConsents.push({
      display_name: 'Matomo Analytics',
      description: 'Erfasst Statistiken über Besuche des Benutzers auf der Website, wie z. B. die Anzahl der Besuche, durchschnittliche Verweildauer auf der Website und welche Seiten gelesen wurden.',
      link: '/datenschutz#matomo-ehemals-piwik',
      default_on: true,
      consentGiven: true,
      locked: false,
      function_id: 'matomo'
    });
  }
  remoteConsents.forEach(consent => availableConsents.push(_objectSpread(_objectSpread({}, consent), {}, {
    consentGiven: false,
    locked: false
  })));
  const {
    0: userConsents,
    1: userConsentDispatcher
  } = useReducer(consentReducer, availableConsents, getConsentsFromLocal);

  // TODO does not belong here
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const html = document.getElementsByTagName('html')[0];
      if (primaryMenuOpen) {
        html.style.overflow = 'hidden';
      } else {
        html.style.overflow = 'auto';
      }
    }
  }, [primaryMenuOpen]);
  return ___EmotionJSX(GlobalContext.Provider, {
    value: {
      primaryMenuOpen,
      togglePrimaryMenu,
      showCookieBanner,
      setShowCookieBanner,
      userConsents,
      userConsentDispatcher,
      isSidebarOpen,
      onSidebarOpen,
      onSidebarClose,
      sidebarContent,
      setSidebarContent
    }
  }, children);
};
const query = "3443985947";